export default "/assets/images/alexa.051449124c515971.webp";